import { useEffect, useRef } from "react";

import { AssistantChatArea } from "@/commands/AssistantOnly/chatAreaComponent";
import { MiiboHookTypes } from "@/hooks/useMiibo";

type Props = {
  isChatLogExpanded: boolean;
  setIsChatLogExpanded: (val: boolean) => void;
  miiboHooks: MiiboHookTypes;
  isMobile: boolean;
  hasAssistantBanner: boolean;
  hasBannerLink: boolean;
  onResetButtonClick: () => void;
};

export function AssistantNormalMode({
  isChatLogExpanded,
  setIsChatLogExpanded,
  miiboHooks,
  isMobile,
  hasAssistantBanner,
  hasBannerLink,
  onResetButtonClick,
}: Props) {
  const isStartedMiibo = useRef(false);
  useEffect(() => {
    if (!isStartedMiibo.current) {
      miiboHooks.startMiibo();
      isStartedMiibo.current = true;
    }
  }, [miiboHooks]);

  return (
    <AssistantChatArea
      setIsChatLogExpanded={setIsChatLogExpanded}
      isChatLogExpanded={isChatLogExpanded}
      miiboHooks={miiboHooks}
      isMobile={isMobile}
      hasAssistantBanner={hasAssistantBanner}
      hasBannerLink={hasBannerLink}
      onResetButtonClick={onResetButtonClick}
    />
  );
}
